<template>
  <div class="container">
    <el-card shadow="never">
    <h2>营业执照信息
    </h2>
    <el-divider/>
    <el-form-item label="商户全称" prop="merchantName">
      <el-input
        class="form-input"
        v-model="businessForm.merchantName"
        :disabled="passed || businessEditable || form.merchantType !== 1"
        type="textarea"
        :rows="2"
        resize="none"
        placeholder="2-40个字，与营业执照名称一致；若为小微商户，应填“商户_XXX”，XXX为小微商户身份证上的姓名"></el-input>
    </el-form-item>
    <el-form-item label="企业证件类型" v-if="form.merchantType !== 1" required>
      <el-select v-model="businessForm.licenseType" :disabled="(passed || businessEditable) && !isUpgrade" @change="$parent.$parent.$refs.businessForm.clearValidate('license')">
        <el-option :value="0" label="营业执照"></el-option>
        <el-option :value="1" label="特殊行业许可证"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="营业执照证照" prop="licensePic" :required="!businessForm.licenseFlag">
      <ocr-recognition
        type="10"
        :disabled="(businessEditable || businessForm.licenseFlag || readOnly) && !isUpgrade"
        :required="!businessForm.licenseFlag"
        :value="businessForm.licensePic"
        valueName="businessForm.licensePic"
        @submit="(data) => getOCRResult(data, 'businessForm.licensePic')"
        :to-check="(needOcr && !businessEditable && !passed) || isUpgrade"></ocr-recognition>
      <el-checkbox v-model="businessForm.licenseFlag" :disabled="form.merchantType !== 1 || businessEditable" style="width:150px;margin-left: 15px;vertical-align: bottom;" @change="resetLicense">暂无营业执照</el-checkbox>
    </el-form-item>
    <el-form-item
      label="营业执照名称"
      prop="licenseFullName"
      :rules="{
        required: !businessForm.licenseFlag,
        message:'请输入2~40位营业执照名称',
        trigger: 'blur'}">
      <el-input
        class="form-input"
        v-model="businessForm.licenseFullName"
        :disabled="(businessForm.licenseFlag || passed || businessEditable) && !isUpgrade"
        type="textarea"
        :rows="3"
        resize="none"
        placeholder="2-40个字，与商户全称一致，若营业执照无商家名称或名称为“*”或“***”，则应填“个体户XXX”，XXX为营业执照上经营者姓名"
        @blur="getLicenseInput"></el-input>
    </el-form-item>
    <el-form-item label="营业执照编号" prop="license" :required="!businessForm.licenseFlag">
      <el-input class="form-input" v-model.trim="businessForm.license" :disabled="(businessForm.licenseFlag || passed || businessEditable) && !isUpgrade" placeholder="营业执照注册号"></el-input>
    </el-form-item>
    <expiry-date
      ref="licenseExpiryDate"
      label="营业执照有效期"
      label-width="122px"
      :value="licenseExpiryDate"
      valueName="license"
      :readOnly="businessEditable || businessForm.licenseFlag || readOnly"
      :required="!businessForm.licenseFlag"
      @change="getExpiryDate"></expiry-date>
    </el-card>
    <el-card shadow="never">
    <h2>门店信息</h2>
    <el-divider/>
    <el-form-item label="经营地址" required>
      <address-select
        ref="addressSelectForm"
        :required="!businessEditable"
        v-model="businessAddress"
        :value="businessAddress"
        :readOnly="readOnly"
        @getValue="getAddress"></address-select>
    </el-form-item>
    </el-card>
    <el-card shadow="never">
    <h2>法人信息</h2>
    <el-divider/>
    <el-form-item label="法人证件类型" prop="credentialType" required>
      <el-select placeholder="请选择证件类型" v-model="businessForm.credentialType" @change="swiftCertType" :disabled="passed || form.merchantType === 1 || businessEditable">
        <el-option label="身份证" :value="1"></el-option>
        <el-option label="港澳台通行证" :value="2"></el-option>
        <el-option label="台湾身份证" :value="3"></el-option>
        <el-option label="香港身份证" :value="4"></el-option>
        <el-option label="澳门身份证" :value="5"></el-option>
        <el-option label="护照" :value="6"></el-option>
        <el-option label="居住证" :value="7"></el-option>
        <el-option label="其他法定证件" :value="9"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="法人证件照" required>
      <el-row type="flex" class="flexRow">
        <el-form-item prop="idcardFrontPic">
          <!--                            身份证可以ocr识别-->
          <ocr-recognition
            v-if="businessForm.credentialType === 1"
            type="8"
            :disabled="businessEditable|| readOnly"
            label="证件照人像面"
            :value="businessForm.idcardFrontPic"
            valueName="businessForm.idcardFrontPic"
            @submit="(data) => getOCRResult(data, 'businessForm.idcardFrontPic')"
            :to-check="needOcr && !businessEditable && !passed"></ocr-recognition>
          <upload-img-ele
            v-else
            ref="idcardFrontPic"
            valueName="businessForm.idcardFrontPic"
            :value="businessForm.idcardFrontPic"
            label="证件照人像面"
            :disabled="businessEditable || readOnly"
            @upload="(data) => uploadSuccess(data, 'businessForm.idcardFrontPic')"></upload-img-ele>
        </el-form-item>
        <el-form-item prop="idcardBackPic" style="margin-left: 20px">
          <!--                            身份证可以ocr识别-->
          <ocr-recognition
            v-if="businessForm.credentialType === 1"
            type="7"
            :disabled="businessEditable|| readOnly"
            label="证件照国徽面"
            :value="businessForm.idcardBackPic"
            valueName="businessForm.idcardBackPic"
            @submit="(data) => getOCRResult(data, 'businessForm.idcardBackPic')"
            :to-check="needOcr && !businessEditable && !passed"></ocr-recognition>
          <upload-img-ele
            v-else
            ref="idcardBackPic"
            valueName="businessForm.idcardBackPic"
            :value="businessForm.idcardBackPic"
            label="证件照国徽面"
            :disabled="businessEditable || readOnly"
            @upload="(data) => uploadSuccess(data, 'businessForm.idcardBackPic')"></upload-img-ele>
        </el-form-item>
      </el-row>

    </el-form-item>
    <el-form-item label="法人姓名" prop="legalName">
      <el-input class="form-input" v-model="businessForm.legalName" placeholder="请输入法人姓名" :disabled="passed || businessEditable"></el-input>
    </el-form-item>
    <el-form-item label="法人证件号" prop="idCardNo">
      <el-input class="form-input" v-model="businessForm.idCardNo" :disabled="passed || businessEditable" :placeholder="credentialLabel.idCardHolder"></el-input>
    </el-form-item>
    <expiry-date
      ref="idCardExpiryDate"
      label="证件有效期"
      label-width="120px"
      :value="idCardExpiryDate"
      :read-only="readOnly || businessEditable"
      required
      value-name="idCard"
      @change="getExpiryDate"></expiry-date>
    </el-card>
    <el-card shadow="never">
    <h2>证照信息</h2>
    <el-divider/>
    <el-form label-width="0" ref="picForm" :model="picForm">
    <div class="photos-content-view">
      <el-form-item label="" prop="doorPic" :rules="{ required: true, message: '请上传门头照', trigger: 'blur' }">
        <upload-img-ele
          label="门头照"
          v-model="picForm.doorPic"
          :disabled="readOnly"
          :value="picForm.doorPic"
          valueName="doorPic"
          @upload="uploadSuccess"
          iconType="el-icon-picture"
          desc="（门头照片，招牌文字清晰可见）"></upload-img-ele>
      </el-form-item>
      <el-form-item label="" prop="cashierDeskPic" :rules="{ required: true, message: '请上传收银台照', trigger: 'blur' }">
        <upload-img-ele
          label="收银台照"
          v-model="picForm.cashierDeskPic"
          :disabled="readOnly"
          :value="picForm.cashierDeskPic"
          valueName="cashierDeskPic"
          @upload="uploadSuccess"
          iconType="el-icon-picture"
          desc="（需包含：标准物料、扫码支付二维码、刷卡支付场景中的支付机具或扫码枪）"></upload-img-ele>
      </el-form-item>
      <el-form-item label="" prop="insidePic" :rules="{ required: true, message: '请上传经营场所照', trigger: 'blur' }">
        <upload-img-ele
          label="经营场所照"
          v-model="picForm.insidePic"
          :disabled="readOnly"
          :value="picForm.insidePic"
          valueName="insidePic"
          @upload="uploadSuccess"
          iconType="el-icon-picture"
          desc="（店内照，请勿拍摄单一物品）"></upload-img-ele>
      </el-form-item>
      <el-form-item label="" prop="agreementPic">
        <upload-img-ele
          v-model="picForm.agreementPic"
          :disabled="readOnly"
          :value="picForm.agreementPic"
          valueName="agreementPic"
          :required="false"
          label="租赁协议或房产证明"
          @upload="uploadSuccess"
          iconType="el-icon-picture"
          desc="（pos进件必传）"></upload-img-ele>
      </el-form-item>
      <el-form-item class='video-tab' prop="agreementPic" v-if='picForm.video'>
        <div class='icon-video' @click='playVideo'>
          <img src="@/assets/img/icon/icon_video_play.png" alt="">
        </div>
        <span>商户经营场所视频</span>
      </el-form-item>
    </div>
    </el-form>
    </el-card>
    <el-card shadow="never">
    <h2>其他补充资料</h2>
    <el-divider/>
      <multi-upload :value="picForm.otherPics" valueName="otherPics" :uploadedValue="picForm.otherPicsPath" :limit="20" @uploaded="multiUploaded" @delete="multiDelete" :disabled="readOnly || isMerchant"></multi-upload>
    </el-card>
    <el-dialog title='商户经营场所视频' :visible.sync="dialogPlay" width="30%" @close='closeVideo'>
        <video :src="picForm.video" controls autoplay class="video" :ref="dialogVideo" id='video1'
        width="100%"></video>
    </el-dialog>
  </div>
</template>

<script>
import addressSelect from '@/components/addressSelect'
import expiryDate from './expiryDate'
import ocrRecognition from '@/components/OCRRecognition'
import uploadImgEle from '@/components/upload/uploadImgEle'
import multiUpload from '@/components/upload/multiUpload'
import { agentMixins } from './agentMixins'
export default {
  mixins: [agentMixins],
  components: {
    addressSelect,
    expiryDate,
    ocrRecognition,
    uploadImgEle,
    multiUpload
  },
  mounted () {
  },
  data () {
    return {
      // 法人证件类型联动信息
      credentialLabel: {
        idCardHolder: '请输入证件号码'
      },
      selectLoading: true,
      dialogPlay: false
    }
  },
  computed: {
    businessAddress () {
      return {
        provinceCode: this.businessForm.provinceCode,
        cityCode: this.businessForm.cityCode,
        areaCode: this.businessForm.areaCode,
        address: this.businessForm.address
      }
    },
    businessEditable () {
      return this.form.businessInfoFlag === 1
    }
  },
  methods: {
    playVideo () {
      this.dialogPlay = true
    },
    closeVideo () {
      var shopVideo = document.getElementById('video1')
      shopVideo.pause()
    },
    swiftCertType (type) {
      if (type === 1) {
        this.credentialLabel.idCardHolder = '请输入15/18位身份证号码'
      } else if (type === 2) {
        this.merchantExcelName = ''
        this.credentialLabel.idCardHolder = '请输入HM开头加8或10位数字的通行证号码'
      } else {
        this.credentialLabel.idCardHolder = '请输入法人证件号码'
      }
      this.businessForm.idCardNo = ''
      this.businessForm.idcardFrontPic = ''
      this.businessForm.idcardBackPic = ''
      this.$parent.$parent.$refs.businessForm.clearValidate('idCardNo')
      if (this.settleForm.legalFlag === 1) {
        this.settleForm.bankIdCardType = this.businessForm.credentialType
      } else {
        this.settleForm.bankIdCardType = 1
      }
    },
    // 获取营业执照名称，复制给商户全称
    getLicenseInput (e) {
      this.businessForm.merchantName = e.target.value
    },
    /**
    * @description 经营地址选中回调
    * @param {Object} val 组件传的参数，经营地址数据
    */
    getAddress (val) {
      this.businessForm.provinceCode = val.provinceCode
      this.businessForm.cityCode = val.cityCode
      this.businessForm.areaCode = val.areaCode
      this.businessForm.address = val.address
      if (!this.isEdit && !this.readOnly) {
        this.storeToLocal()
      }
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
.red label{
        color: red;
    }
    .form-input {
        width: 450px;
    }
    .form-flex-item {
        margin-right: 5px;
    }
    .form-tip-label {
      margin: 0;
      color:#D49B5F;
      vertical-align:middle;
      display:inline-block;
      font-size:14px;
      font-family:Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
    }
    .file-download-button {
        color: #409eff;
        margin: 0 10px;
    }
    .report-config-id-tip-view {
        margin: 10px 100px;
        color: #606266;
        font-size: 14px;
    }
    @mixin flex-horizontal {
        display: -webkit-box;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .is-participate-view {
        @include flex-horizontal;
            margin-bottom: 10px;
        .is-participate-view-title {
            margin-right: 30px;
        }
    }
    .report-config-id-tip-view {
        margin: 10px 100px;
        color: #606266;
        font-size: 14px;
    }
    .merchant-info-head-view {
        @include flex-horizontal;
        justify-content: space-between;
        .merchant-info-title-view {
            flex: 1;
        }
        .merchant-info-batch-import-view {
            .merchant-info-batch-import-buttons {
                @include flex-horizontal;
            }
            .new-file-tip {
                font-size: 14px;
                margin: 5px 0;
            }
            .new-file-name {
                font-size: 14px;
            }
        }
    }
    .photos-content-view {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        .video-tab {
          display: flex;
          justify-content: center;
          .icon-video {
            border: 2px dashed #c0ccda;
            width: 120px;
            height: 120px;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 40%;
              height: 40%;
            }
          }
        }
    }
    .photos-content-view .el-form-item{
        margin-right: 40px;
        width: 200px;
        text-align: center;
    }
    .changePhone{
        position: absolute;
        left: 600px;
    }
    .submitBtn{
        display: block;
        margin: 20px auto;
    }
    .flexRow .el-form-item{
        width: 150px;
    }
    p.form-tip-label{
      display: block;
    }
</style>
